import "../css/bookingtable.css";
import Table from "@mui/material/Table";
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Spinner, Modal, Container, Row, Col } from "react-bootstrap"

//firebase
import { useState, useEffect } from "react";
import { db } from "../firestore-db";
import { storage } from "../firebase";
import "firebase/compat/storage";
import { getStorage, ref, getDownloadURL, listAll } from 'firebase/storage';
import 'firebase/compat/firestore';
import {
    query,
    collection,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
    orderBy,
    where,
    startAt,
    endAt
} from "firebase/firestore";

import * as MdIcons from "react-icons/md";
import * as BiIcons from "react-icons/bi";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.common.white,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const List = () => {

    const [loading, setLoading] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);
    const [selUserDoc, setSelUserDoc] = useState([]);
    // const [usersData, setUserData] = useState([]);
    const dataCollectionRef = db.collection("users");

    const [show, setShow] = useState(false);
    const [imgUrl, setImgUrl] = useState("");

    const [search, setSearch] = useState("");
    const [fields, setField] = useState("");
    const [books, setBookData] = useState([]);

    // get booking data
    const getBook = async () => {
        setLoading(true);

        if (fields === null) {
            var orderField = "tutorName";
        }
        else if (fields == "-- Select Filter --") {
            var orderField = "tutorName";
        }
        else if (fields == "Tutor Name") {
            var orderField = "tutorName";
        }
        else if (fields == "Subject") {
            var orderField = "selSubject";
        }
        else if (fields == "City") {
            var orderField = "city";
        }
        else if (fields == "Province") {
            var orderField = "province";
        }
        else if (fields == "Status") {
            var orderField = "sessionStatus";
        }

        if (search.length === 0) {
            var bookCollectionRef = query(collection(db, "tutorBookingProfile"), orderBy("tutorName"));
        }
        else if (search.length > 1) {
            // panget kabonding ni firebase sa query
            var bookCollectionRef = query(collection(db, "tutorBookingProfile"), orderBy(orderField), startAt(search), endAt(search + '~'));
        }

        const data = await getDocs(bookCollectionRef);

        setBookData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

        setTimeout(() => {
            setLoading(false)
        }, 1100);
    };

    const handleClose = () => {
        setShow(false)
    };

    const handleShow = async (userid) => {
        setShow(true);
        setLoadingModal(true);

        const getUserRef = db.collection("tutorBookingProfile");

        getUserRef.where("tutorId", "==", userid)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    setSelUserDoc(querySnapshot.docs.map((doc) => doc.data()));
                });
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });

        const imageListRef = ref(storage, "userprofiles/profile_" + userid + ".jpg");

        getDownloadURL(imageListRef)
            .then((imahe) => {
                // Inserting url into an object
                console.log(imahe);
                setImgUrl(imahe);
            })
            .catch((error) => {
                const noProfileRef = ref(storage, "/no_profile_pic.png");

                console.log(error)
                console.log(error.code)

                getDownloadURL(noProfileRef).then((noImg) => {
                    // Inserting no profile url into an object
                    setImgUrl(noImg);
                })

            });

        setTimeout(() => {
            setLoadingModal(false)
        }, 1500);
    };

    const handleAvl = async (id) => {
        setShow(false);
        getBook();

        var concatAdd;

        selUserDoc.map((selusers) => (
            concatAdd = selusers.concatAddress
        ));

        console.log(id);
        const userDoc = doc(db, "tutorBookingProfile", id);
        const newFields = { sessionStatus: "Available" };
        await updateDoc(userDoc, newFields);

        const userDoc2 = doc(db, "tutorBookingProfile", id);
        const newFields2 = { locSessionStatus: concatAdd + "_Available" };
        await updateDoc(userDoc2, newFields2);

        setTimeout(() => {
            handleShow(id);
        }, 1100);

    };

    const handleUnavl = async (id) => {
        setShow(false);
        getBook();

        var concatAdd;

        selUserDoc.map((selusers) => (
            concatAdd = selusers.concatAddress
        ));

        console.log(id);
        const userDoc = doc(db, "tutorBookingProfile", id);
        const newFields = { sessionStatus: "Unavailable" };
        await updateDoc(userDoc, newFields);

        const userDoc2 = doc(db, "tutorBookingProfile", id);
        const newFields2 = { locSessionStatus: concatAdd + "_Unavailable" };
        await updateDoc(userDoc2, newFields2);

        setTimeout(() => {
            handleShow(id);
        }, 1100);
    };

    const deleteUser = async (userid) => {
        const userDoc = doc(db, "tutorBookingProfile", userid);
        console.log(userDoc);
        await deleteDoc(userDoc);
        getBook();
    };

    // load booking data
    useEffect(() => {
        getBook();
    }, [search]);

    return (
        <>

            <div className="book-header">
                <div className="book-listTitle">
                    <h4> Manage Tutoring Booking List </h4>
                </div>

                <div className="book-drp-search" >
                    <select className="drp-dwn" value={fields} onChange={(e) => setField(e.target.value)}>
                        <option >-- Select Filter --</option>
                        <option >Tutor Name</option>
                        <option >Subject</option>
                        <option >City</option>
                        <option >Province</option>
                        <option >Status</option>
                    </select>
                </div>

                <div className="book-search">
                    <input
                        className="book-search-item"
                        placeholder="Search..."
                        onChange={(e) => setSearch(e.target.value.toString())}
                    />
                </div>
            </div>

            <TableContainer component={Paper} className="booking-table">

                {
                    loading ?

                        <div className="loader">
                            <Spinner animation="grow" variant="primary" />
                        </div>

                        :
                        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table">
                            <TableHead className="tableHeader">
                                <StyledTableRow>
                                    <StyledTableCell className="tableCell">Name</StyledTableCell>
                                    <StyledTableCell className="tableCell">Tutoring Subject</StyledTableCell>
                                    <StyledTableCell className="tableCell">Tutoring Location</StyledTableCell>
                                    <StyledTableCell className="tableCell">Session Status</StyledTableCell>
                                    <StyledTableCell className="tableCell"> </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>

                                {books.map((book) => (
                                    <StyledTableRow hover key={book.tutorId}>

                                        <TableCell className="tableCell">
                                            {/* <img src={row.img} alt="" className="image" /> */}
                                            <div className="cellWrapper"> {book.tutorName} </div>
                                        </TableCell>

                                        <TableCell className="tableCell">{book.selSubject}</TableCell>
                                        <TableCell className="tableCell">{book.city}, {book.province} </TableCell>

                                        <TableCell className="tableCell">
                                            <span className={`book-status-${book.sessionStatus}`} > {book.sessionStatus} </span>
                                        </TableCell>

                                        {/* {usersData.map((userdata) => ( 
                                <TableCell className="tableCell">
                                    <span className={`status ${userdata.tutorVerification}`} > {userdata.tutorVerification} </span>
                                </TableCell>
                            ))} */}

                                        <TableCell className="tableCell">
                                            <div className="actions-btn">
                                                <Button variant="primary" size="sm" onClick={() => { handleShow(book.tutorId) }}> <MdIcons.MdOutlineInfo /> View Details </Button>

                                                <Button variant="danger" size="sm" onClick={() => { deleteUser(book.tutorId) }} > <MdIcons.MdOutlineDelete /> Delete </Button>
                                            </div>
                                        </TableCell>

                                    </StyledTableRow>
                                ))}

                            </TableBody>
                        </Table>
                }
            </TableContainer>
            <>
                <Modal
                    size="lg"
                    show={show}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    {
                        loadingModal ?

                            <div className="loader">
                                <Spinner animation="grow" variant="primary" />
                            </div>

                            :

                            <>
                                <Modal.Header closeButton>
                                    {selUserDoc.map((selusers) => (
                                        <Modal.Title> <h3 style={{ paddingTop: '20px' }}> <strong> Tutor - </strong> {selusers.tutorName} </h3> </Modal.Title>
                                    ))
                                    }
                                </Modal.Header>

                                <Modal.Body>

                                    {selUserDoc.map((selusers) => (

                                        <>
                                            <Container>
                                                <Row>
                                                    <Col xs={6} md={4}>
                                                        <div className="profile-container">
                                                            <img src={imgUrl} alt="profile" className="profile" />
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                        <p > <strong style={{ color: "#069" }} > Account Registered Date: </strong> {selusers.dateJoined} </p>
                                                        <p > <strong style={{ color: "#069" }} > Session Status: </strong> {selusers.sessionStatus}  </p>
                                                        <p> <strong style={{ color: "#069" }} > Education: </strong> {selusers.tutorEduc}  </p>
                                                        <p> <strong style={{ color: "#069" }} > Rates Per Hour: </strong> Php {selusers.ratesHr}  </p>
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row>
                                                    <Col xs={6} md={6}>
                                                        <br />
                                                        <p> <strong style={{ color: "#069" }} > Tutoring Grade Levels: </strong> <p> {selusers.selGradeLvls} </p> </p>
                                                        <p> <strong style={{ color: "#069" }} > Tutoring Subject: </strong> <p>  {selusers.selSubject} </p> </p>
                                                        <p> <strong style={{ color: "#069" }} > Tutoring Location: </strong> <p> {selusers.city}, {selusers.province} {selusers.postal} </p> </p>
                                                        <p> <strong style={{ color: "#069" }} > Tutoring Time Availability: </strong> <p> {selusers.timeFromAvl} to {selusers.timeToAvl} </p> </p>
                                                    </Col>
                                                    <Col xs={6} md={6}>
                                                        <p> <strong style={{ color: "#069" }} > Tutoring Day Availability: </strong>
                                                            <p className={`day-status-${selusers.sunAvl}`} > Sunday: </p>
                                                            <p className={`day-status-${selusers.monAvl}`} > Monday: </p>
                                                            <p className={`day-status-${selusers.tuesAvl}`} > Tuesday: </p>
                                                            <p className={`day-status-${selusers.wedAvl}`} > Wednesday: </p>
                                                            <p className={`day-status-${selusers.thurAvl}`} > Thursday: </p>
                                                            <p className={`day-status-${selusers.friAvl}`} > Friday: </p>
                                                            <p className={`day-status-${selusers.satAvl}`} > Saturday: </p>
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Container>
                                            {/* <p> <strong> Phone Number: </strong> {selusers.phoneNum} </p>
                                            <p> <strong> Gender: </strong> {selusers.gender} </p> */}
                                        </>

                                    ))}
                                </Modal.Body>

                                <Modal.Footer>
                                    {selUserDoc.map((selusers) => (
                                        <>
                                            <Button variant="success" onClick={() => { handleAvl(selusers.tutorId) }} > Mark as Available </Button>
                                            <Button variant="danger" onClick={() => { handleUnavl(selusers.tutorId) }} > Mark as Unavailable </Button>
                                        </>
                                    ))}
                                </Modal.Footer>
                            </>

                    }
                </Modal>
            </>
        </>
    );
};

export default List;